import { render, staticRenderFns } from "./UserDataModalContent.vue?vue&type=template&id=2fc8a166&lang=pug&"
import script from "./UserDataModalContent.vue?vue&type=script&lang=js&"
export * from "./UserDataModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports